/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import dynamic from 'next/dynamic';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { getSiteId } from '@tcp/core/src/utils/utils';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { getSearchRedirectObj } from '@tcp/core/src/utils/utils.web';
import {
  getIcidValue,
  internalCampaignProductAnalyticsList,
  internalPromotionFormattedProducts,
  fireEnhancedEcomm,
} from '@tcp/core/src/utils';
import { renderRelatedSearches } from '@tcp/core/src/components/features/browse/SearchDetail/views/SearchKeywords.view';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import { isTier1Device } from '@tcp/web/src/utils/device-tiering';
import { setProp } from '@tcp/core/src/analytics/utils';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import {
  SearchByKeywordsContainer,
  EmptySearchResultTitle,
  EmptySearchResultSuggestion,
  SuggestionLabel,
  EmptySearchInputBoxContainerWrapper,
  EmptySearchInputBoxCol,
  SearchTipsMessageContainerWrapper,
  EmptySearchTipsTitle,
  EmptySearchTipsItems,
  SlpRelatedNoResponseSearch,
  DidYouMeanContainer,
} from '../NoResponseSearchDetail.style';
import {
  getSearchResult,
  setNOSearchResultPageFlag,
  manageHandleClickOutside,
  resetSlpProducts,
} from '../container/SearchDetail.actions';
import { updateLocalStorageData } from '../../../../common/molecules/SearchBar/userRecentStore';
import { routerPush } from '../../../../../utils/index';
import CONSTANTS from '../../../../common/molecules/SearchBar/SearchBar.constants';
import NoResponseInputContainer from './NoResponseInputContainer.view';
import BopisFilter from '../../ProductListing/molecules/BopisFilter/views/BopisFilter';
import BopisFilterEmptyResults from '../../ProductListing/molecules/BopisFilterEmptyResults';
import { SLASH_C_PATH, SLASH_C_ROUTE } from '../../../../../constants/plp.constants';
import { isShopThisStoreModeOn } from '../../../../../reduxStore/selectors/session.selectors';
import { getStoreFilterData } from '../../ShopThisStore/container/ShopThisStore.utils';
import {
  SLP_SUB_LABELS,
  lblRecentlyViewed,
  slpSubLabels,
} from '../../../../../utils/labels/browse/SLP.labels';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import {
  SEARCH_BAR_LABELS,
  SearchBarLabels,
} from '../../../../common/molecules/SearchBar/labels/searchBar.labels';

const Recommendations = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "recommendations" */ '@tcp/core/src/components/common/molecules/Recommendations'
  )
);

class NoResponseSearchDetailView extends React.PureComponent {
  slpLabels = getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels);

  recentlyViewed = getDynamicLabelValues(`dynamic.browse_d.${lblRecentlyViewed}`);

  labels = getLabelFromCopyOrFromTranslation(`${SEARCH_BAR_LABELS}`, SearchBarLabels);

  constructor(props) {
    super(props);
    const { searchResultKeywordSuggestions } = this.props;
    this.state = {
      slpRelatedSearches: searchResultKeywordSuggestions,
    };
  }

  componentDidMount() {
    const { searchType, searchedText } = this.props;

    if (searchType && searchedText) {
      this.triggerAnalyticsCall();
      pushEventToAdobeAnalytics('internal_search', {
        searchedText,
        searchType,
        totalProductsCount: 0,
      });
    }
    this.willAlsoViewedCarouselDisplay = isTier1Device();
  }

  triggerAnalyticsCall = () => {
    const {
      trackPageLoad,
      searchType,
      searchedText,
      asPathVal,
      oldSearchResultSuggestions,
      isDidYouMeanEnabled,
    } = this.props;
    const icid = getIcidValue(asPathVal);
    const products = internalCampaignProductAnalyticsList();
    const analyticsEvents = ['event91', 'event92', 'event80'];
    const didYouMeanNulAnalytics =
      isDidYouMeanEnabled && oldSearchResultSuggestions ? searchedText : '';

    if (icid) {
      analyticsEvents.push('event81');
    }

    const searchRedirect = getSearchRedirectObj();
    if (searchRedirect && !searchRedirect.isDone) {
      analyticsEvents.push('event21');
      if (isShopThisStoreModeOn()) {
        analyticsEvents.push('event167');
      }
    }
    setProp('eVar30', 'zero');
    if (!icid) {
      setProp('eVar94', '+1');
    }
    trackPageLoad({
      pageSearchType: icid ? '' : searchType,
      pageSearchText: icid ? '' : searchedText,
      pageType: 'search',
      pageName: 'search:results',
      pageSection: 'search',
      pageSubSection: 'search',
      customEvents: analyticsEvents,
      pageNavigationText: '',
      listingCount: 'zero',
      internalCampaignIdList: products,
      cd104: didYouMeanNulAnalytics,
      ...(icid && { internalCampaignId: icid }),
    });
    if (products) {
      fireEnhancedEcomm({
        eventName: 'internalcampaignimpression',
        productsObj: internalPromotionFormattedProducts(products),
        eventType: 'promoView',
        pageName: 'No Response Search Detail',
        currCode: 'USD',
      });
    }
    pushEventToAdobeAnalytics(
      'promotional_banner_impression',
      internalPromotionFormattedProducts(products)
    );
  };

  setDataInLocalStorage = (searchText, url) => {
    updateLocalStorageData(searchText, url);
  };

  getParameterForUrl = (params, url) => {
    if (params) {
      return url?.includes('?') ? `&${params}` : `?${params}`;
    }
    return '';
  };

  createParams = () =>
    isShopThisStoreModeOn()
      ? `bopisStoreId=${encodeURIComponent(getStoreFilterData())}&sort=newest_score desc`
      : '';

  // Utility function to handle router push
  handleRouterPush = (searchText, params) => {
    if (isShopThisStoreModeOn()) {
      routerPush(
        `/search/shop-this-store?searchQuery=${searchText}&searchType=typeahead:keyword${
          params ? `&${params}` : ''
        }`,
        `/search/shop-this-store/${searchText}${params ? `?${params}` : ''}`,
        { shallow: true }
      );
    } else {
      routerPush(
        `/search?searchQuery=${searchText}&searchType=typeahead:keyword${
          params ? `&${params}` : ''
        }`,
        `/search/${searchText}${params ? `?${params}` : ''}`,
        { shallow: true }
      );
    }
  };

  redirectToSuggestedUrl = (searchText, url) => {
    if (searchText) {
      this.setDataInLocalStorage(searchText, url);
      const params = this.createParams();
      if (url) {
        const appendParam = this.getParameterForUrl(params, url);
        routerPush(
          `${SLASH_C_PATH}searchType=${CONSTANTS.ANALYTICS_TYPEAHEAD_CATEGORY}&cid=${
            url.split(SLASH_C_ROUTE)[1]
          }${params ? `&${params}` : ''}`,
          `${url}${appendParam}`,
          { shallow: false }
        );
      } else {
        this.handleRouterPush(searchText, params);
      }
    }
  };

  didYouMeanCheck = (
    isDidYouMeanEnabled,
    searchResultSuggestionsArg,
    oldSearchResultSuggestions
  ) => {
    if (!isDidYouMeanEnabled && searchResultSuggestionsArg) {
      return searchResultSuggestionsArg;
    }
    if (oldSearchResultSuggestions) {
      return oldSearchResultSuggestions;
    }
    return searchResultSuggestionsArg;
  };

  relatedSearch = (
    isSlpPersistEnabled,
    isDidYouMeanEnabled,
    slpRelatedSearches,
    trackClickAnalyticsBopisFilter,
    searchedText
  ) => {
    return (
      <SlpRelatedNoResponseSearch
        isSlpPersistEnabled={isSlpPersistEnabled}
        isDidYouMeanEnabled={isDidYouMeanEnabled}
      >
        {isSlpPersistEnabled &&
          isDidYouMeanEnabled &&
          renderRelatedSearches(slpRelatedSearches, trackClickAnalyticsBopisFilter, searchedText)}
      </SlpRelatedNoResponseSearch>
    );
  };

  renderInsteadSearch = (
    isDidYouMeanEnabled,
    oldSearchResultSuggestions,
    searchResultSuggestionsArg,
    resetProducts
  ) => {
    const onClickLink = (e) => {
      e.preventDefault();
      resetProducts();
      this.redirectToSuggestedUrl(
        `${this.didYouMeanCheck(
          isDidYouMeanEnabled,
          searchResultSuggestionsArg,
          oldSearchResultSuggestions
        )} `
      );
    };
    return (
      isDidYouMeanEnabled &&
      oldSearchResultSuggestions && (
        <BodyCopy
          component="div"
          fontFamily="secondary"
          fontWeight="semibold"
          className="instead-search-label"
        >
          {isShopThisStoreModeOn()
            ? `${renderLabel(
                this.slpLabels.lbl_shopThisStore_searchInstead,
                'lbl_shopThisStore_searchInstead'
              )} "`
            : `${renderLabel(this.slpLabels.lbl_search_instead, 'lbl_search_instead')} "`}
          {isShopThisStoreModeOn() ? (
            <SuggestionLabel
              noLink
              className="suggestion-label"
              to={`/${getSiteId()}/search/shop-this-store/${this.didYouMeanCheck(
                isDidYouMeanEnabled,
                searchResultSuggestionsArg,
                oldSearchResultSuggestions
              )}`}
              onClick={(e) => {
                onClickLink(e);
              }}
              didyoumeanflag={isDidYouMeanEnabled}
            >
              {`${this.didYouMeanCheck(
                isDidYouMeanEnabled,
                searchResultSuggestionsArg,
                oldSearchResultSuggestions
              )}`}
            </SuggestionLabel>
          ) : (
            <SuggestionLabel
              noLink
              className="suggestion-label"
              to={`/${getSiteId()}/search/${this.didYouMeanCheck(
                isDidYouMeanEnabled,
                searchResultSuggestionsArg,
                oldSearchResultSuggestions
              )}`}
              onClick={(e) => {
                onClickLink(e);
              }}
              didyoumeanflag={isDidYouMeanEnabled}
            >
              {`${this.didYouMeanCheck(
                isDidYouMeanEnabled,
                searchResultSuggestionsArg,
                oldSearchResultSuggestions
              )}`}
            </SuggestionLabel>
          )}
          {`"?`}
        </BodyCopy>
      )
    );
  };

  renderEmptySearch = () => {
    const {
      className,
      searchResults,
      startSearch,
      showProduct,
      showRecent,
      toggleSearchFlag,
      manageHandleClickOutsideFunc,
      isSlpPersistEnabled,
      isDidYouMeanEnabled,
    } = this.props;
    return (
      <EmptySearchInputBoxContainerWrapper
        className="empty-search-inputBox-container-wrapper"
        didyoumeanflag={isDidYouMeanEnabled}
      >
        <EmptySearchInputBoxCol
          className="empty-search-inputBox-col"
          colSize={{ small: 6, medium: 8, large: 3 }}
        >
          <NoResponseInputContainer
            className={className}
            slpLabels={this.slpLabels}
            searchResults={
              isSlpPersistEnabled && !searchResults?.autosuggestProducts?.length
                ? []
                : searchResults
            }
            startSearch={startSearch}
            labels={this.labels}
            redirectToSuggestedUrl={this.redirectToSuggestedUrl}
            showProduct={showProduct}
            showRecent={showRecent}
            toggleSearchFlag={toggleSearchFlag}
            manageHandleClickOutsideFunc={manageHandleClickOutsideFunc}
          />
        </EmptySearchInputBoxCol>
      </EmptySearchInputBoxContainerWrapper>
    );
  };

  renderSlpNoSearch = ({
    isSlpPersistEnabled,
    isDidYouMeanEnabled,
    slpRelatedSearches,
    trackClickAnalyticsBopisFilter,
    searchedText,
  }) => {
    return (
      <SlpRelatedNoResponseSearch>
        {isSlpPersistEnabled &&
          !isDidYouMeanEnabled &&
          renderRelatedSearches(slpRelatedSearches, trackClickAnalyticsBopisFilter, searchedText)}
      </SlpRelatedNoResponseSearch>
    );
  };

  getEmptyLabelVal = (searchedText) => {
    return searchedText.indexOf('?') > 0 ? searchedText.split('?')[0] : searchedText;
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  render() {
    const {
      className,
      searchedText,
      searchResultSuggestions,
      resetProducts,
      isBopisFilterOn,
      formValues,
      getProducts,
      onSubmit,
      updateFormValue,
      setBopisFilterStateActn,
      isBopisFilterEnabled,
      resetSuggestedStores,
      slpPersistSearchTerm,
      isSlpPersistEnabled,
      isDidYouMeanEnabled,
      searchResultKeywordSuggestions,
      trackClickAnalyticsBopisFilter,
      oldSearchResultSuggestions,
      isFeatureBrandView,
      isFeatureBrandEnabled,
    } = this.props;
    if (isSlpPersistEnabled && slpPersistSearchTerm === searchedText) {
      this.setState({
        slpRelatedSearches: searchResultKeywordSuggestions,
      });
    }
    const { slpRelatedSearches } = this.state;

    const showNewBopisFilterEmptyMessage = isBopisFilterOn;

    const getEmptyLabelVal = this.getEmptyLabelVal(searchedText);

    const searchResultSuggestionsArg =
      searchResultSuggestions && searchResultSuggestions.length
        ? searchResultSuggestions.map((searchSuggestion) => searchSuggestion.suggestion)
        : renderLabel(this.slpLabels.lbl_no_suggestion, 'lbl_no_suggestion');

    const recommendationAttributes = {
      variations: 'moduleO',
      page: Constants.RECOMMENDATIONS_PAGES_MAPPING.NULL_SEARCH,
      showLoyaltyPromotionMessage: false,
      headerAlignment: 'left',
    };
    return (
      <div className={className}>
        <SearchByKeywordsContainer
          className="search-by-keywords-container"
          didyoumeanflag={isDidYouMeanEnabled}
        >
          {this.renderSlpNoSearch({
            isSlpPersistEnabled,
            isDidYouMeanEnabled,
            slpRelatedSearches,
            trackClickAnalyticsBopisFilter,
            searchedText,
          })}
          {isBopisFilterEnabled && (
            <Col colSize={{ small: 6, medium: 8, large: 12 }}>
              <BopisFilter
                isBopisFilterOn={isBopisFilterOn}
                formValues={formValues}
                getProducts={getProducts}
                onSubmit={onSubmit}
                updateFormValue={updateFormValue}
                setBopisFilterStateActn={setBopisFilterStateActn}
                defaultStoreData={JSON.parse(getLocalStorage('defaultStore')) || {}}
                resetSuggestedStores={resetSuggestedStores}
                isFeatureBrandView={isFeatureBrandView}
                isFeatureBrandEnabled={isFeatureBrandEnabled}
              />
            </Col>
          )}
        </SearchByKeywordsContainer>
        {showNewBopisFilterEmptyMessage && !isShopThisStoreModeOn() && (
          <Row>
            <BopisFilterEmptyResults />
          </Row>
        )}
        {!showNewBopisFilterEmptyMessage && !isDidYouMeanEnabled ? (
          <EmptySearchResultTitle className="empty-search-result-title">
            <Col colSize={{ small: 6, medium: 8, large: 12 }}>
              <BodyCopy
                component="div"
                fontSize={['fs16', 'fs32', 'fs32']}
                fontFamily="secondary"
                fontWeight="semibold"
                textAlign="center"
              >
                {renderLabel(this.slpLabels.lbl_nothing_matched, 'lbl_nothing_matched')}
                <span className="empty-searched-label-title">{` "${getEmptyLabelVal}"`}</span>
              </BodyCopy>
            </Col>
          </EmptySearchResultTitle>
        ) : (
          <DidYouMeanContainer isDidYouMeanEnabled={isDidYouMeanEnabled}>
            <div>
              <BodyCopy
                component="div"
                fontSize={['fs32']}
                fontFamily="secondary"
                className="no-result-label"
              >
                {`${renderLabel(
                  this.slpLabels?.lbl_noresults_found_for,
                  'lbl_noresults_found_for'
                )} "`}
                <BodyCopy
                  component="span"
                  className="no-result-text"
                  fontFamily="secondary"
                  fontWeight="extrabold"
                >{`${getEmptyLabelVal}"`}</BodyCopy>
              </BodyCopy>
              {this.renderInsteadSearch(
                isDidYouMeanEnabled,
                oldSearchResultSuggestions,
                this.slpLabels,
                searchResultSuggestionsArg,
                resetProducts
              )}
              {this.relatedSearch(
                isSlpPersistEnabled,
                isDidYouMeanEnabled,
                slpRelatedSearches,
                trackClickAnalyticsBopisFilter,
                searchedText
              )}
              <BodyCopy
                component="div"
                className="tips-null-search"
                fontFamily="secondary"
                fontWeight="semibold"
              >
                <div className="better-results">
                  {renderLabel(this.slpLabels.lbl_try_better_results, 'lbl_try_better_results')}
                </div>
                <ul>
                  <li className="didyoumean-list">
                    {renderLabel(this.slpLabels.lbl_try_reducing_search, 'lbl_try_reducing_search')}
                  </li>
                  <li className="didyoumean-list">
                    {renderLabel(this.slpLabels.lbl_check_spelling, 'lbl_check_spelling')}
                  </li>
                  <li className="didyoumean-list">
                    {renderLabel(
                      this.slpLabels.lbl_browse_product_category,
                      'lbl_browse_product_category'
                    )}
                  </li>
                </ul>
              </BodyCopy>
            </div>
          </DidYouMeanContainer>
        )}
        {!showNewBopisFilterEmptyMessage &&
          !isDidYouMeanEnabled &&
          searchResultSuggestionsArg !==
            renderLabel(this.slpLabels.lbl_no_suggestion, 'lbl_no_suggestion') && (
            <EmptySearchResultSuggestion className="empty-search-result-suggestion">
              <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                <BodyCopy
                  fontSize={['fs16', 'fs32', 'fs32']}
                  component="div"
                  fontFamily="secondary"
                  fontWeight="semibold"
                  textAlign="center"
                >
                  {`${renderLabel(this.slpLabels.lbl_didYouMean, 'lbl_didYouMean')} `}
                  <SuggestionLabel
                    noLink
                    className="suggestion-label"
                    to={`/${getSiteId()}/search/${this.didYouMeanCheck(
                      isDidYouMeanEnabled,
                      searchResultSuggestionsArg,
                      oldSearchResultSuggestions
                    )}`}
                    onClick={(e) => {
                      e.preventDefault();
                      resetProducts();
                      this.redirectToSuggestedUrl(
                        `${this.didYouMeanCheck(
                          isDidYouMeanEnabled,
                          searchResultSuggestionsArg,
                          oldSearchResultSuggestions
                        )}`
                      );
                    }}
                  >
                    {`"${this.didYouMeanCheck(
                      isDidYouMeanEnabled,
                      searchResultSuggestionsArg,
                      oldSearchResultSuggestions
                    )}"`}
                  </SuggestionLabel>
                </BodyCopy>
              </Col>
            </EmptySearchResultSuggestion>
          )}
        {!isShopThisStoreModeOn() && this.renderEmptySearch()}
        <Row className="pdp-recommendations-wrapper">
          <Col colSize={{ small: 6, medium: 8, large: 12 }}>
            <div className={`${className} product-description-list`}>
              <Recommendations
                {...recommendationAttributes}
                sequence="1"
                productImageWidth={164}
                productImageHeight={170}
                searchNoResultRecommendation={true}
                page="null_search"
                isNewPDPEnabled={true}
                headerLabelNoSearchResult={renderLabel(
                  this.labels.lbl_you_may_like,
                  'lbl_you_may_like'
                )}
              />
            </div>
          </Col>
        </Row>

        {!isDidYouMeanEnabled && (
          <SearchTipsMessageContainerWrapper className="search-tips-message-container-wrapper">
            <Col colSize={{ small: 6, medium: 8, large: 12 }}>
              <BodyCopy fontSize="fs16" component="div" fontFamily="secondary" textAlign="center">
                <EmptySearchTipsTitle
                  fontSize={['fs12', 'fs16', 'fs16']}
                  component="div"
                  textAlign="center"
                  fontWeight="black"
                  className="empty-search-tips-title"
                  fontFamily="secondary"
                >
                  {renderLabel(this.slpLabels.lbl_tips, 'lbl_tips')}
                </EmptySearchTipsTitle>
                <EmptySearchTipsItems className="empty-search-tips-items">
                  <BodyCopy
                    fontSize={['fs12', 'fs16', 'fs16']}
                    color="gray.1000"
                    fontFamily="secondary"
                    textAlign="center"
                  >
                    {renderLabel(this.slpLabels.lbl_check_your_spelling, 'lbl_check_your_spelling')}
                  </BodyCopy>
                  <BodyCopy
                    fontSize={['fs12', 'fs16', 'fs16']}
                    color="gray.1000"
                    fontFamily="secondary"
                    textAlign="center"
                  >
                    {renderLabel(this.slpLabels.lbl_simplified_keywords, 'lbl_simplified_keywords')}
                  </BodyCopy>
                  <BodyCopy
                    fontSize={['fs12', 'fs16', 'fs16']}
                    color="gray.1000"
                    fontFamily="secondary"
                    textAlign="center"
                  >
                    {renderLabel(this.slpLabels.lbl_try_searching, 'lbl_try_searching')}
                  </BodyCopy>
                  <BodyCopy
                    fontSize={['fs12', 'fs16', 'fs16']}
                    color="gray.1000"
                    fontFamily="secondary"
                    textAlign="center"
                  >
                    {renderLabel(this.slpLabels.lbl_narrow_searches, 'lbl_narrow_searches')}
                  </BodyCopy>
                </EmptySearchTipsItems>
              </BodyCopy>
            </Col>
          </SearchTipsMessageContainerWrapper>
        )}
        {this.willAlsoViewedCarouselDisplay && (
          <Row>
            <Col colSize={{ small: 6, medium: 8, large: 12 }}>
              <div className="product-detail-section">
                <Recommendations
                  headerLabel={renderLabel(this.recentlyViewed, 'lbl_recently_viewed')}
                  portalValue={Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED}
                  sequence="2"
                  {...recommendationAttributes}
                />
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

NoResponseSearchDetailView.propTypes = {
  className: PropTypes.string,
  searchedText: PropTypes.string,
  searchResultSuggestions: PropTypes.arrayOf(
    PropTypes.shape({
      suggestion: PropTypes.string.isRequired,
    })
  ),
  startSearch: PropTypes.func.isRequired,
  searchResults: PropTypes.shape({
    trends: PropTypes.shape({}),
    categories: PropTypes.shape({}),
    products: PropTypes.shape({}),
  }),
  trackPageLoad: PropTypes.func,
  searchType: PropTypes.string,
  showProduct: PropTypes.bool,
  showRecent: PropTypes.bool,
  toggleSearchFlag: PropTypes.func,
  manageHandleClickOutsideFunc: PropTypes.func,
  resetProducts: PropTypes.func,
  asPathVal: PropTypes.string,
};

NoResponseSearchDetailView.defaultProps = {
  className: '',
  searchedText: '',
  searchResultSuggestions: [],
  searchResults: {
    trends: {},
    categories: {},
    products: {},
  },
  searchType: 'keyword',
  trackPageLoad: () => {},
  showProduct: false,
  showRecent: false,
  toggleSearchFlag: () => {},
  manageHandleClickOutsideFunc: () => {},
  resetProducts: () => {},
  asPathVal: '',
};

const mapStateToProps = (state) => {
  return {
    searchResults: state.Search.searchResults,
    showProduct: state.SearchListingPage.showProduct,
    showRecent: state.SearchListingPage.showRecent,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    startSearch: (payload) => {
      dispatch(getSearchResult(payload));
    },
    toggleSearchFlag: (payload) => {
      dispatch(setNOSearchResultPageFlag(payload));
    },
    manageHandleClickOutsideFunc: (payload) => {
      dispatch(manageHandleClickOutside(payload));
    },
    resetProducts: (payload) => {
      dispatch(resetSlpProducts(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NoResponseSearchDetailView);
